const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgChile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf283d62-9fbf-48bc-86f5-fc333235e80f",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aea991ca-0487-44c7-aa16-cd4da84c8fa4{fill:#003671;}.e356b887-8c6c-4bb6-a728-2ef145632f2e{fill:#fff;fill-rule:evenodd;}")), /*#__PURE__*/React.createElement("rect", {
    className: "aea991ca-0487-44c7-aa16-cd4da84c8fa4",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "e356b887-8c6c-4bb6-a728-2ef145632f2e",
    d: "M20.82,11h1.54a34.38,34.38,0,0,1,4.85,1.05h.65a1.67,1.67,0,0,0,.81-.32.68.68,0,0,1,.32.16L22.6,16.42s-1.94,1-1.94,1.86v11.4l-6.3,4.37c.09-.61.89-1.16.89-2V20.78c0-.87,6.06-4,6.06-4.93s-3.56-1.62-3.56-1.62c-1.13,0-1.6,0-2.75,0s-2.39.76-2.83.73C13.55,14.05,17.24,11,20.82,11Zm12.94.24c1,0,1.56,1,3.24,3.24.41.54,2.34,2.9,2.34,4v.89c0,2.3-6.06,4.62-6.06,5.58,0,.65,3.18.35,4.61,1.29a5.13,5.13,0,0,1,1.94,3.88v2.75c0,1.65-2.26,2.27-5,4.37A54.68,54.68,0,0,1,29.15,41s-4.74-2.59-7-2.59H19.05c-1.29,0-4.45,1.13-4.69,1.13,0,0,4.77-4.69,9.62-4.69h3.23A22,22,0,0,1,30.77,36V15.45a.68.68,0,0,0-.65-.57c-.89,0-1.53,1.63-1.53,1.7V28.79c0,.54-2.1,2.18-3.24,2.83-1.69,1-2.78,1.92-3.8,2.43V33.8s.89-1,.89-1.53V19c0-.17,1.43-2,5.34-4.21C30.05,13.49,32.36,11.24,33.76,11.24ZM31.9,16.82s2.59,2.82,2.59,4.53c0,1.29-1,1.8-2.59,2.75Zm0,9.54c.25.07,1.7.93,1.7,1.54v9.3c-.4.19-.08,0-.32,0-.51,0-1.38-.4-1.38-.89Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/CHILE.7dec6a65c27bd98a21a9009234a9ffce.svg";
export { ForwardRef as ReactComponent };